// src/js/pages/LicenseExpired.js
import { navigateTo } from "../framework/router.ts";
import { LicenseExpiredSkin } from "../components/skins/license-expired.ts";

export default function LicenseExpiredPage() {
  const container = document.createElement("div");
  container.classList.add("default_layout", "h-100");
  container.innerHTML = new LicenseExpiredSkin().htmlskin();

  const retryBtn = container.querySelector("#retryLogin");
  const contactBtn = container.querySelector("#contactSupport");

  retryBtn.addEventListener("click", () => {
    navigateTo("/login");
  });

  contactBtn.addEventListener("click", () => {
    // You can customize this action (open mail client, redirect to support page, etc.)
    window.open("mailto:info@lapomikenergy.com?subject=License Renewal Request");
  });

  return container;
}
